import { FuseNavigationItem } from "@fuse/types";
import { EditionNames } from "app/wapps/system/subscription/edition-names";

interface OrderingStruct {
    editions?: string[],
    navigationOrder: string[]
}

const EngageEditions: OrderingStruct = {
    editions: [EditionNames.HealthEngagePro, EditionNames.HealthEngagePremium, EditionNames.HealthEngageStarter],
    navigationOrder: ["dashboard", "mobile-app", "calendar", "health.patients", "vSaude.Pay", "financial", "report", "communication", "professional-medical-procedures", "settings"],
}

const DefaultOrder: OrderingStruct = {
    navigationOrder: ["dashboard", "calendar", "health.patients", "vSaude.Pay", "financial", "report", "communication", "mobile-app", "professional-medical-procedures", "settings"],
}

export class NavigationTools {
    public static buildEditionNavigation(editionName: string, menuItems: FuseNavigationItem[]): FuseNavigationItem[] {
        let targetOrder: string[];

        if (EngageEditions.editions.includes(editionName)) {
            targetOrder = EngageEditions.navigationOrder;
        } else {
            targetOrder = DefaultOrder.navigationOrder;
        }

        const itemMap = new Map<string, FuseNavigationItem>();

        const processedIds = new Set<string>();

        menuItems.forEach((item) => {
            if (item.id) {
                itemMap.set(item.id, item);
            }
        });

        const reorderedItems: FuseNavigationItem[] = [];

        targetOrder.forEach((id) => {
            const item = itemMap.get(id);

            if (item) {
                reorderedItems.push(item);
                processedIds.add(id);
            }
        });

        menuItems.forEach((item) => {
            if (item.id && !processedIds.has(item.id)) {
                reorderedItems.push(item);
            }
        });

        return reorderedItems;
    }
}
